import React, { forwardRef } from "react"
import { Error } from "@components/FormFields/styles"
import { RadioGroupProps } from "./types"
import {
    RadioWrapper, StyledIndicator, StyledLabel, StyledPrimitiveRadioGroup, StyledRadio
} from "./styles"

const RadioGroup = forwardRef<HTMLInputElement, RadioGroupProps>(({
    options,
    label,
    error,
    ...props
}, ref) => {
    return <StyledPrimitiveRadioGroup ref={ref} {...props}>
        <StyledLabel>{label}</StyledLabel>
        {options && options.map((option) => {
            return <RadioWrapper key={option.value}>
                <StyledRadio value={option.value} id={option.value}>
                    <StyledIndicator />
                </StyledRadio>
                <label htmlFor={option.value}>{option.label}</label>
            </RadioWrapper>
        })}
        {error && <Error>{error}</Error>}
    </StyledPrimitiveRadioGroup>
})

export default RadioGroup
